import { ref, watch } from 'vue'
import { registerApi } from '../services/registerApi.js'

export function useReferralLookup(referralCode, onResult) {
  const isLookingUp = ref(false)
  let timer = null

  const lookup = async (code) => {
    if (!code || code.length < 8) {
      onResult({ companyName: '', error: '' })
      return
    }

    isLookingUp.value = true

    try {
      const { data } = await registerApi.lookupReferral(code)
      if (data.status === 'success' && data.company) {
        onResult({ companyName: data.company, error: '' })
      } else {
        onResult({ companyName: '', error: data.message ?? 'Invalid referral code.' })
      }
    } catch {
      onResult({ companyName: '', error: 'Unable to verify referral code.' })
    } finally {
      isLookingUp.value = false
    }
  }

  watch(referralCode, (code) => {
    clearTimeout(timer)
    timer = setTimeout(() => lookup(code), 400)
  })

  return { isLookingUp, lookup }
}
